module.exports = __webpack_public_path__ + "img/check-circle-disable.831c8b62.svg";